import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import withTracker from './components/withTracker'

import Menu from './components/Menu.js'
import Game from './components/Game.js'

import './App.css';

class App extends Component {
  render() {
    return (
      <Switch>
        <Route parent path='/game' component={withTracker(Game)} />
        <Route component={withTracker(Menu)} />
      </Switch>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js